import { Col } from 'antd'
import { FC } from 'react'
import { createSearchParams, useNavigate } from 'react-router-dom'
import { formatNumber } from '../../../../util/formatNumber'
import { getColor } from '../../../../util/getColor'
import { Badges } from '../Badges'
import Styles from './HeaderBadges.module.scss'

interface Props {
    data: LeaderBoard[]
}

export const HeaderBadges: FC<Props> = ({ data }) => {
    const navigate = useNavigate()

    const badgeClickHandler = (data: LeaderBoard) => {
        navigate({
            pathname: '/my-profile',
            search: createSearchParams({
                search: data.additional_user_info.accountId.toString(),
            }).toString(),
        })
    }

    return (
        <div className={Styles.container}>
            {data &&
                data.map((badge, index) => (
                    <Col span={8}>
                        <Badges
                            color={getColor(+badge.score)}
                            key={badge.user_key}
                            type={badge.tier.name}
                            rank={`${formatNumber(
                                +badge.score,
                                false,
                                false,
                                true
                            )}%`}
                            name={badge.additional_user_info.profileName}
                            highlighted={index === 1}
                            onClick={() => badgeClickHandler(badge)}
                        />
                    </Col>
                ))}
        </div>
    )
}
